import { QuoteSetupItems } from '@/models/cart'
import { MapElementWithSectorId } from '@/models/map'
import { QuoteReservation } from '@/models/quote'
import { Service } from '@/models/service'
import { getServiceIdFromKey } from './serviceIdKeyUtils'

// This util is necessary to keep track of
// 1) amount of services of the same group added to cart
// 2) amount of services of the same group selected on the current open spot in SelectedElementDrawer
// the end goal is to avoid surpassing the group limit and prevent overbooking
export const sumServiceGroupSelectedQuantity = ({
  groupId,
  ticketServices,
  cartReservations,
  selectedElement,
  selectedElementQuotableProducts,
}: {
  groupId: number
  ticketServices: Service[]
  cartReservations: QuoteReservation[]
  selectedElement: MapElementWithSectorId
  selectedElementQuotableProducts: QuoteSetupItems
}) => {
  const groupedServicesIds = ticketServices
    .filter((ticket) => ticket.serviceGroupId === groupId)
    .map((ticket) => ticket.serviceId)

  const cartReservationsExcludingSelectedElement = cartReservations.filter(
    (reservation) =>
      reservation.spotName !== selectedElement.name ||
      reservation.spotType !== selectedElement.subType
  )

  const aggregatedCartServiceQuantities =
    cartReservationsExcludingSelectedElement
      .map((res) => res.services)
      .reduce((acc, curr) => {
        Object.entries(curr).forEach(([key, value]) => {
          acc[key] = (acc[key] || 0) + value
        })
        return acc
      }, {})

  const groupQuantityInCart = Object.entries(aggregatedCartServiceQuantities)
    .map(([key, value]) => {
      if (groupedServicesIds.includes(getServiceIdFromKey(key))) {
        return value
      }
      return 0
    })
    .filter((value) => value !== null)
    .reduce((acc, curr) => acc + curr, 0)
  const groupQuantityInSelectedElement = Object.entries(
    selectedElementQuotableProducts.services
  )
    .map(([key, value]) => {
      if (groupedServicesIds.includes(getServiceIdFromKey(key))) {
        return value
      }
      return 0
    })
    .filter((value) => value !== null)
    .reduce((acc, curr) => acc + curr, 0)

  const totalGroupSelectedQuantity =
    groupQuantityInCart + groupQuantityInSelectedElement
  return totalGroupSelectedQuantity
}
